import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GameIconComponent } from '@core/components/game-icon/game-icon.component';
import { InfoModalMaxPayoutComponent } from '@core/components/game-board/info-modal-max-payout/info-modal-max-payout.component';

@Component({
  selector: 'app-plinko-info-modal',
  imports: [GameIconComponent, InfoModalMaxPayoutComponent],
  templateUrl: './plinko-info-modal.component.html',
  styleUrl: './plinko-info-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PlinkoInfoModalComponent {
  readonly MAX_PAYOUT = 5_000;
}
